import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
import styles from '../../styles/modal.module.scss';

const RemoveReferredByDoctorModal = ({
  visible,
  onConfirm,
  onCancel,
  loading,
  userName,
}) => (
  <Modal open={visible} footer={null} closeIcon={null} onCancel={onCancel}>
    <div className={styles.modal}>
      <p className={styles.modal__title}>Ukloni mentorsku preporuku</p>
      <p className={styles.modal__message}>
        Da li ste sigurni da želite da uklonite mentorsku preporuku za korisnika{' '}
        <strong>{userName}</strong>?
      </p>
      <div className={styles.modal__buttons}>
        <Button className="btn-tertiary" onClick={onCancel} disabled={loading}>
          <span>Odustani</span>
        </Button>
        <Button
          className="btn-primary red-button"
          onClick={onConfirm}
          disabled={loading}
        >
          <img src="/assets/icons/delete-white.svg" alt="Remove Icon" />
          <span style={{ marginLeft: '8px' }}>
            {loading ? 'Uklanjanje...' : 'Ukloni preporuku'}
          </span>
        </Button>
      </div>
    </div>
  </Modal>
);

RemoveReferredByDoctorModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  userName: PropTypes.string,
};

export default RemoveReferredByDoctorModal;
